<app-progress-indicator />
<upper-menu-component />
<p-toast />
<p-confirmDialog />
<router-outlet class="router-flex" />
